import React from "react";

export default (props) => (
    <i className={`sprite sprite-index-round`} />
);
